





























































import { Prop, Component, Vue, Ref } from "vue-property-decorator";
import AbcToolButton from "../button/AbcToolButton.vue";
import HammerJs from "hammerjs";

@Component({
    components: {
        AbcToolButton,
    },
})
export default class AbcCarousel extends Vue {
    @Ref("slider") slider!: HTMLDivElement;

    @Prop() items!: unknown[];
    @Prop() value!: number;
    @Prop({ type: Boolean }) removeContainer!: boolean;
    @Prop({ type: Boolean }) allowOverflow!: boolean;
    @Prop({ type: Boolean }) hideResume!: boolean;

    private touch!: HammerManager;
    private curPage = 0;
    private previousPage = -1;
    private isHover = false;

    private get currentPage() {
        return this.value || this.curPage;
    }

    private set currentPage(val: number) {
        this.$emit("input", val);
        this.curPage = val;
    }

    private get showResume() {
        if (this.hideResume) {
            return this.isHover;
        }
        return true;
    }

    private setIsHover(val: boolean) {
        window.setTimeout(() => (this.isHover = val), 150);
    }

    mounted() {
        if (this.touch) {
            this.destroyed();
        }
        this.touch = new HammerJs(this.slider);
        this.touch.on("swiperight", () => this.changePage(-1));
        this.touch.on("swipeleft", () => this.changePage(1));
    }

    destroyed() {
        this.touch.destroy();
    }

    private changePage(page: number) {
        this.previousPage = this.currentPage;
        const tempPage = this.currentPage + page;
        if (tempPage < 0 || tempPage > this.items.length - 1) {
            return;
        }
        this.currentPage = tempPage;
    }

    private setPage(page: number) {
        this.previousPage = this.currentPage;
        this.currentPage = page;
    }
}
